import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { PhoneNumber } from 'src/app/models/data/user';
import { ApiService } from 'src/app/services/api.services';
import { EditProfileMode } from '../../profile/profile.component';
import { StepperDetails } from '../register-user.component';
import { VerificationCodeComponent } from '../../../components/verification-code/verification-code.component';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-verify-mobile-number',
	templateUrl: './verify-mobile-number.component.html',
	styleUrls: [
		'./verify-mobile-number.component.scss',
		'../../common/main.scss',
		'../register-user.component.scss',
	],
	imports: [VerificationCodeComponent, MatButton],
})
export class VerifyMobileNumberComponent {
	@Input() userId = '';
	@Input() mobilePhoneNumber: PhoneNumber | undefined;
	@Output() updateStepperDetails = new EventEmitter<StepperDetails>();

	isNextButtonDisabled = true;
	mode = EditProfileMode.mobilePhoneNumber;

	constructor(
		private readonly stepper: MatStepper,
		private readonly apiService: ApiService
	) {}

	verificationCodeEventResult(event: boolean): void {
		this.isNextButtonDisabled = !event;
	}

	async onResendClicked(): Promise<void> {
		if (this.mobilePhoneNumber?.rawPhoneNumber !== undefined) {
			await this.apiService.requestPhoneVerificationCode(
				this.userId,
				this.mobilePhoneNumber.rawPhoneNumber
			);
		}
	}

	onNextButtonClicked(): void {
		this.updateStepperDetails.emit({ stepProgress: '50', stepCount: '3' });
		this.stepper.next();
	}

	onBackButtonClicked(): void {
		this.updateStepperDetails.emit({ stepProgress: '10', stepCount: '1' });
		this.stepper.previous();
	}
}
